<button *ngIf="!activeScore" class="popup__close" (click)="onClose()">
  <!-- <img src="../../../../assets/images/Ic_cross_pop_up-white.svg" alt="cross" /> -->
  <span [innerHTML]="ICONS.closeCircleIcon | safeHtml"></span>
</button>
<div *ngIf="!activeScore" class="image__gallery--popup">
  <div class="image--gallery">
    <div class="modal__content">
      <div class="modal__body">
        <aside class="feed_css">
          <owl-carousel-o class="detailfeedCarousel" *ngIf="data.postMedias.length > 0 && isInitialized" [options]="customOptions">
            <ng-container class="detailfeedContainer" *ngFor="let item of data.postMedias">
              <ng-template class="detailfeedSlide" carouselSlide>
                <div class="profile__image">
                  <img
                    *ngIf="item.mediaType == 'image'"
                    [src]="fileDirectoriesPath + item.mediaUrl"
                    alt="Snowboarding Image"
                    class="profile__image--photo"
                  />
                  <video
                    controls
                    #videoPlayer
                    *ngIf="item.mediaType == 'video'"
                    poster=""
                    class="profile__image--photo"
                    preload="metadata"
                    [src]="fileDirectoriesPath + item.mediaUrl"
                  >
                    <source [src]="fileDirectoriesPath + item.mediaUrl" type="video/mp4" />
                  </video>
                  <figcaption>
                    @if (query.usedFor == 'myFeed' && data.reviewStatus == 'pending') {
                      <span class="user-directory__status user-directory__status--pending position__top"
                        >Review pending

                        <img src="assets/images/ic_info_blue.svg" alt="Review pending" class="info__icon tootltip_new" />
                        <div class="show__tooltip_new">The review is currently awaiting evaluation from the assigned experts.</div>
                      </span>
                    }
                    @if (query.usedFor == 'myFeed' && data.reviewStatus == 'not_required') {
                      <span class="user-directory__status user-directory__status--notRequired position__top"
                        >Not required <img src="assets/images/ic_info-grey.svg" alt="Not required" class="info__icon tootltip_new" />
                        <div class="show__tooltip_new">
                          No review is necessary as this sport follows an objective scoring system with a direct score assigned.
                        </div>
                      </span>
                    }
                    @if (query.usedFor == 'myFeed' && data.reviewStatus == 'rejected') {
                      <span class="user-directory__status user-directory__status--danger position__top"
                        >Review rejected <img src=" assets/images/ic_info-danger.svg" alt="Review rejected" class="info__icon tootltip_new" />
                        <div class="show__tooltip_new">
                          The review was rejected as it failed to meet the minimum required criteria, specifically because this is not classified as
                          an extreme sport on our platform.
                        </div>
                      </span>
                    }
                    @if (query.usedFor == 'myFeed' && data.reviewStatus == 'completed') {
                      <span class="user-directory__status user-directory__status--completed position__top"
                        >Review completed <img src="assets/images/ic_info-green.svg" alt="Review completed" class="info__icon tootltip_new" />
                        <div class="show__tooltip_new">The review has been finalized and assessed by 5 experts.</div>
                      </span>
                    }
                  </figcaption>
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </aside>
        <div class="content__info h-100">
          <div class="user__popup">
            <div class="user__infos">
              <img
                (click)="userSearch(data.user)"
                *ngIf="data.user?.profilePicture"
                [src]="fileDirectoriesPath + data.user?.profilePicture"
                alt="User Image"
                class="user__images handPointer"
              />
              <div class="user__detail">
                <h2 class="user__name">{{ data.user?.alias ? data.user?.alias || '-' : data.user?.name || '-' }}</h2>
                <p class="user__location">{{ data.location || '-' }}</p>
              </div>
            </div>
            <div class="user__tags">
              <span class="user__tag" *ngIf="query.usedFor != 'public' && query.usedFor != 'searchFeed' && query.usedFor != 'myFeedUser'">{{
                data?.level?.sport?.category?.element?.name || '-'
              }}</span>
              <span class="user__tag" *ngIf="query.usedFor != 'public' && query.usedFor != 'searchFeed' && query.usedFor != 'myFeedUser'">{{
                data?.level?.sport?.category?.name || '-'
              }}</span>
              <span *ngIf="query.usedFor == 'public' || query.usedFor == 'searchFeed' || query.usedFor == 'myFeedUser'">{{
                data.createdAt | date: DATE_FORMAT
              }}</span>
            </div>
          </div>
          <div class="middle_panel">
            <div class="date--records" *ngIf="query.usedFor != 'public' && query.usedFor != 'searchFeed' && query.usedFor != 'myFeedUser'">
              <div class="date__info">
                <span class="date__label">Uploaded date</span>
                <span class="date__entry">{{ data.updatedAt | date: DATE_FORMAT }}</span>
              </div>
              <div class="date__info">
                <span class="date__label">Date of entry</span>
                <span class="date__entry">{{ data.createdAt | date: DATE_FORMAT }}</span>
              </div>
            </div>
            <div class="experience">
              <h3 class="experience__title">{{ data?.title || '' }}</h3>
              <p class="experience__description">{{ data?.description || '' }}</p>
            </div>
            @if (query.usedFor == 'myFeed' && data.reviewStatus == 'rejected') {
              <div class="experience">
                <h3 class="experience__title">Reason for rejection</h3>
                <p class="experience__description">{{ data?.rejectReason || '' }}</p>
              </div>
            }
            <div
              class="score--info"
              *ngIf="
                query.usedFor != 'public' &&
                query.usedFor != 'searchFeed' &&
                query.usedFor != 'myFeedUser' &&
                !(query.usedFor == 'myFeed' && data.reviewStatus == 'rejected')
              "
            >
              <h4 class="score__title">Scores</h4>
              <div class="score__current">
                <p>Current scores for your snowboarding videos and images:</p>

                <div class="score">
                  <div class="score__value">
                    <span class="score__number">{{ data?.selfScore || 0 }}</span>
                    <span class="score__label">Self Score</span>
                  </div>

                  @if (!(query.usedFor == 'myFeed' && data.reviewStatus == 'pending')) {
                    <div class="score__value">
                      <span class="score__number">{{ data?.averageExpertScores || 0 }}</span>
                      <span class="score__label">Total Score</span>
                    </div>
                  }
                </div>
                @if (data.canBeScored && query.usedFor != 'public' && query.usedFor != 'myFeed') {
                  <div class="score__add">
                    <div class="score__heading">
                      <h6>Add your score</h6>
                      <p>Add Your Score for Skateboarding Video/Images</p>
                    </div>
                    <button class="score__assign-btn handPointer" (click)="openScoreUserPopup()">Assign Score</button>
                  </div>
                }
              </div>
            </div>
            <div *ngIf="query.usedFor == 'searchFeed' || query.usedFor == 'myFeedUser' || query.usedFor == 'public' || query.usedFor == 'myFeed'">
              <div class="actionCount">
                <span class="likewrap">
                  <span class="{{ likeFeed ? 'likeRedCount likeCount' : 'likeCount' }}" (click)="likeFeeds(data?.id, userDetail?.id)">
                    <div [innerHTML]="ICONS.likeIcon | safeHtml"></div>
                  </span>
                  <span class="handPointer" (click)="openLikeList(data)">{{ likeCount || 0 }}</span>
                </span>
                <span class="commentCount">
                  <div [innerHTML]="ICONS.commentIcon | safeHtml"></div>
                  {{ commentCount || 0 }}</span
                >
              </div>
            </div>
          </div>
          <div
            *ngIf="query.usedFor == 'searchFeed' || query.usedFor == 'myFeedUser' || query.usedFor == 'public' || query.usedFor == 'myFeed'"
            class="detailfeedComment"
          >
            <app-comment-box [DetailsFeed]="data" (closeBox)="onClose()" (commentCount)="postCount()"></app-comment-box>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
